import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FaviconService {
  constructor() {}

  changeFavicon(tenantCode: string) {
    const basePath = `assets/img/favicon_assets/${tenantCode}/`;
    const cacheBuster = `?v=${Date.now()}`;

    const faviconData = [
      {
        rel: 'icon',
        type: 'image/png',
        sizes: '180x180',
        href: `${basePath}favicon-180x180.png${cacheBuster}`,
      },
      {
        rel: 'icon',
        type: 'image/png',
        href: `${basePath}favicon-32x32.png${cacheBuster}`,
      },
      {
        rel: 'apple-touch-icon',
        sizes: '180x180',
        href: `${basePath}favicon-180x180.png${cacheBuster}`,
      },
    ];

    this.removeExistingFavicons();

    faviconData.forEach((data) => {
      const link = document.createElement('link');
      link.rel = data.rel;
      link.type = data.type || '';
      link.href = data.href;

      if (data.sizes) {
        link.setAttribute('sizes', data.sizes);
      }

      document.head.appendChild(link);
    });
  }

  private removeExistingFavicons() {
    const existingLinks = document.querySelectorAll(
      "link[rel*='icon'], link[rel='apple-touch-icon']",
    );
    existingLinks.forEach((link) => link.parentNode?.removeChild(link));
  }
}
